<jhi-spinner *ngIf="circleLoading"></jhi-spinner>
<jhi-alert></jhi-alert>
<div class="col-xl">
  <div class="card-wrapper">
    <div class="card card-bg">
      <div class="card-body">
        <div class="container">
        <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
            <li class="breadcrumb-item" *ngIf="checkListaPrenotazioni()"><a href="javascript:void(0)" (click)="goToListaPrenotazioni()">Lista prenotazioni</a><span class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Dati prenotazione</a></li>
          </ol>
        </nav>
        </div>
        <div style="justify-content: center;">
          <div class="container">
            <div class="row" style="justify-content: center;">
              <div class="col-xl-10 col-lg-12">
                <div class="card no-after">
                  <div id="custom-card-body" class="card-body my-3 pt-0 pb-0">
                    <div class="d-flex flex-wrap" style="justify-content:center">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-2">
                        <div class="d-flex" style="justify-content:center">
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati" jhiTranslate="progressBar.iTuoiDati">
                              Dati
                            </div>
                            <button disabled class="btn rounded-circle p-1 btn-actual-step border-circle">1
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label" jhiTranslate="progressBar.servizio">
                              Servizio
                            </div>
                            <button class="btn-next-step btn rounded-circle p-1" disabled>2
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label" jhiTranslate="progressBar.dataOra">Data e ora
                            </div>
                            <button class="btn-next-step btn rounded-circle btn-primary p-1" disabled>3</button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label" jhiTranslate="progressBar.riepilogo">Riepilogo</div>
                            <button class="btn-next-step btn rounded-circle btn-primary p-1" disabled>4</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <form *ngIf="initDone && formDatiRichiedente" [formGroup]="formDatiRichiedente">
            <div joyrideStep="primoStep" formGroupName="appuntamento"
                 [stepContent]="primoStep" [nextTemplate]="nextButton" [prevTemplate]="prevButton">

              <div formGroupName="dichiarante">

                <div class="row" style="justify-content: center;">
                  <div class="col-xl-10 col-lg-12">
                    <div class="card no-after my-2 pb-0">
                      <div class="card-body mt-0 mb-0 pt-0 pb-0">

                        <div class="row" style="justify-content: center;">
                          <div class="col-xxl-4 col-xl-5 col-lg-12 col-md-12 col-sm-12 p-2 mt-2 ps-xxl-3">

                            <div class="form-group mb-1 ml-3 mr-3"
                                 [ngClass]="{'wrong-form': getNome.invalid && getNome.touched, '': getNome.valid}">
                              <label [ngClass]="{'active': getNome.value != ''}" for="inputNome"
                                     jhiTranslate="form.nome">Nome</label>
                              <input formControlName="nome"
                                     [ngClass]="{'fw-normal': appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id}"
                                     [readonly]="appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id && appuntamento.dichiarante !== null"
                                     id="inputNome" class="form-control" type="text"
                                     [class.is-invalid]="getNome.invalid && getNome.touched">
                            </div>
                            <small class="text-danger" jhiTranslate="dipendente.aggiunta.errNome"
                                   *ngIf="getNome.invalid && getNome.touched">Nome non valido</small>


                          </div>

                          <div class="col-xxl-4 col-xl-5 col-lg-12 col-md-12 col-sm-12 p-2 mt-2 pe-xxl-3">

                            <div class="form-group mb-1 ml-3 mr-3"
                                 [ngClass]="{'wrong-form': getCognome.invalid && getCognome.touched, '': getCognome.valid}">
                              <label [ngClass]="{'active': getCognome.value != ''}" for="inputCognome"
                                     jhiTranslate="form.cognome">Cognome</label>
                              <input formControlName="cognome"
                                     [ngClass]="{'fw-normal': appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id}"
                                     [readonly]="appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id && appuntamento.dichiarante !== null"
                                     id="inputCognome" class="form-control" type="text"
                                     [class.is-invalid]="getCognome.invalid && getCognome.touched">
                            </div>
                            <small class="text-danger" jhiTranslate="dipendente.aggiunta.errCognome"
                                   *ngIf="getCognome.invalid && getCognome.touched">Cognome non valido</small>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" style="justify-content: center;margin-top: -15px;">
                  <div class="col-xl-10 col-lg-12">
                    <div class="card no-after my-2 pb-0">
                      <div class="card-body mt-0 mb-0 pt-0 pb-0">
                        <div class="row" style="justify-content: center;">
                          <div class="col-xxl-4 col-xl-5 col-lg-12 col-md-12 col-sm-12 p-2 mt-2 ps-xxl-3">

                            <div class="form-group mb-1 ml-3 mr-3"
                                 [ngClass]="{'wrong-form': getDataDiNascita.invalid && getDataDiNascita.touched, '': getDataDiNascita.valid}">
                              <label class="active" for="inputDataNascita" jhiTranslate="form.dataDiNascita">Data di
                                nascita</label>
                              <input formControlName="dataNascita"
                                     [ngClass]="{'fw-normal': appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id}"
                                     [readonly]="appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id && appuntamento.dichiarante !== null"
                                     id="inputDataNascita" class="form-control" type="date"
                                     [class.is-invalid]="getDataDiNascita.invalid && getDataDiNascita.touched">
                            </div>
                            <small class="text-danger" jhiTranslate="dipendente.aggiunta.errDataDiNascita"
                                   *ngIf="getDataDiNascita.invalid && getDataDiNascita.touched">dt non valida</small>


                          </div>

                          <div class="col-xxl-4 col-xl-5 col-lg-12 col-md-12 col-sm-12 p-2 mt-2 pe-xxl-3">

                            <div class="form-group mb-1 ml-3 mr-3"
                                 [ngClass]="{'wrong-form': getCF.invalid && getCF.touched, '': getCF.valid}">
                              <label [ngClass]="{'active': getCF.value != ''}" for="inputCodiceFiscale"
                                     jhiTranslate="form.cf">cf</label>
                              <input (change)="upper()" maxlength="16" formControlName="cf"
                                     [ngClass]="{'fw-normal': appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id}"
                                     [readonly]="appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id && appuntamento.dichiarante !== null"
                                     id="inputCodiceFiscale" class="form-control text-uppercase" type="text"
                                     [class.is-invalid]="getCF.invalid && getCF.touched">
                            </div>
                            <small class="text-danger" jhiTranslate="dipendente.aggiunta.errCF"
                                   *ngIf="getCF.invalid && getCF.touched">Inserire un cf valido.</small>


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row" style="justify-content: center;">
                <div class="col-xxl-7 col-xl-9 col-lg-12 px-xxl-4 px-xl-3">
                  <div class="card my-2 pb-0">
                    <div class="card-body mt-0 mb-0 pt-0 pb-0">


                      <!--start card-->
                      <div class="card my-3 card-teaser rounded shadow-lg">
                        <div class="card-body">
                          <h5 class="card-title h5">
                            <svg class="icon">
                              <use href="./content/svg/sprites.svg#it-telephone"></use>
                            </svg>
                            <span class="link-info" jhiTranslate="form.DatiDiContatto">Dati di contatto</span>
                            <p class="card-header"><span class="link-secondary">(!)</span><span jhiTranslate="form.avvisioDatiContatto">&nbsp;I dati di contatto del cittadino per le comunicazioni.</span></p>
                          </h5>
                          <div class="row" style="justify-content: space-evenly;">
                            <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 p-2 mt-2">

                              <div class="form-group mb-1 ml-3 mr-3"
                                   [ngClass]="{'wrong-form': getEmailC.invalid && getEmailC.touched, '': getEmailC.valid}">
                                <label [ngClass]="{'active': getEmailC.value != ''}" for="inputEmail"
                                       jhiTranslate="form.email">E-mail</label>
                                <input formControlName="email"
                                       [ngClass]="{'fw-normal': appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id}"
                                       id="inputEmail" class="form-control" type="email"
                                       [class.is-invalid]="getEmailC.invalid && getEmailC.touched">
                              </div>
                              <small class="text-danger" jhiTranslate="dipendente.aggiunta.errEmail"
                                     *ngIf="getEmailC.invalid && getEmailC.touched">Inserire un e-mail valida.</small>

                            </div>

                            <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 p-2 mt-2">

                              <div class="form-group mb-1 ml-3 mr-3"
                                   [ngClass]="{'wrong-form': getNumTel.invalid && getNumTel.touched, '': getNumTel.valid}">
                                <label [ngClass]="{'active': getNumTel.value != ''}" for="inputNumero"
                                       jhiTranslate="form.numTel">Numero telefonico</label>
                                <input formControlName="tel"
                                       [ngClass]="{'fw-normal': appuntamento?.dichiarante?.id === appuntamento?.richiedente?.id}"
                                       id="inputNumero" class="form-control" type="email"
                                       [class.is-invalid]="getNumTel.invalid && getNumTel.touched">
                              </div>
                              <small class="text-danger" jhiTranslate="dipendente.aggiunta.errNumero"
                                     *ngIf="getNumTel.invalid && getNumTel.touched">Inserire un tel valido.</small>

                            </div>
                          </div>
                        </div>
                        <!--end card-->


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="justify-content: center;">
              <div class="col-xl-10 col-lg-12">
                <div class="my-2 pb-0">
                  <div class="card-body mt-4 mb-0 pt-0 pb-0">
                    <div class="d-flex justify-content-between">
                      <button (click)="goBack()" class="btn btn-primary primary-button" jhiTranslate="form.indietro">Indietro</button>
                      <button type="button" (click)="goToSceltaServiziPrenotazione()"
                              [ngClass]="{'disabled': formDatiRichiedente.invalid}" class="btn btn-primary primary-button"
                              jhiTranslate="form.procedi" joyrideStep="secondoStepPrenotazione"
                              [stepContent]="secondoStep" [nextTemplate]="nextButton" [prevTemplate]="prevButton">
                        Procedi
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <button class="btn btn-secondary btn-xs btn-tour" (click)="onTour();">Tour</button>
</div>

<ng-template #nextButton>
  <button class="btn btn-xs btn-primary" jhiTranslate="tour.button.nextButton">Vai avanti</button>
</ng-template>
<ng-template #prevButton>
  <button class="btn btn-xs btn-primary" jhiTranslate="tour.button.prevButton">Torna Indietro</button>
</ng-template>
<ng-template #primoStep>
  <h3 jhiTranslate="tour.inserimento-dati-prenotazione.primoStep-h3">Inserisci tutti i dati richiesti</h3>
  <p jhiTranslate="tour.inserimento-dati-prenotazione.primoStep-p">Se la prenotazione è per te stesso i campi saranno
    compilati automaticamente</p>
</ng-template>
<ng-template #secondoStep>
  <h3 jhiTranslate="tour.inserimento-dati-prenotazione.secondoStep-h3">Premi il bottone prosegui per continuare la
    prenotazione</h3>
  <p></p>
</ng-template>

